import { IonContent } from '@ionic/react';

import { WelcomeScreen } from '@/core/components/auth/welcome-screen';
import { AppIonPage } from '@/core/components/app-ion-page';

export function WelcomePage() {
  return (
    <AppIonPage>
      <IonContent className="ion-padding" fullscreen scrollY={false}>
        <div className="bg-background text-foreground flex h-full w-full safe-area-padding">
          <WelcomeScreen />
        </div>
      </IonContent>
    </AppIonPage>
  );
}
